import RoleContainer from "../../../Components/DataTables/Role/RoleContainer";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const Role = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Role Directory";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard userRoles={currentUserRoles} allowedRoles={["admin"]} />

      {/* Main content */}
      <RoleContainer />
    </>
  );
};

export default Role;
